module.exports = __webpack_public_path__ + "media/professionalBundles/luxury-a0425bc7.png";